export default function swProd() {
    let swUrl = `${process.env.PUBLIC_URL}/sw-prod.js`;
    navigator.serviceWorker.register(swUrl, {scope: "."}).then((response) => {
    });
    let swUrlFirebase = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;
    navigator.serviceWorker.register(swUrlFirebase, {scope: "firebase-cloud-messaging-push-scope"}).then((response) => {
    })
}